import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { Tool } from '../utils/tool.utils';

export const toolSelector = ({ tool }: DefaultRootState) => tool;

export const isToolActiveSelector = (...tools: Tool[]) =>
  createSelector(toolSelector, ({ activeTool }) =>
    tools.some((tool) => activeTool === tool),
  );
